import React, { useState, useEffect } from "react";
import { Container, Grid, Box, TextField, Button, Autocomplete } from '@mui/material';
import { logEventos } from "../../../services/services";
import { getData, putData, postData } from "../../../services/library";
import Notify from "../../Notify";
import moment from "moment";
import Title from "../../Title";
import FormPrecios from './FormPrecios';
import FormActualizar from "./FormActualizar";

export default function Addprecio(props) {
    const [datoslista, setdatosLista] = useState({
        id_producto: null,
        precio_iva: "",
        precio_sin_iva: "",
        vigencia: "",
        fin_vigencia: "",
        usuario: localStorage.getItem('user')
    });

    const fechaVigencia = moment(datoslista.vigencia);
    const fechaFinVigencia = fechaVigencia.subtract(1, 'day');
    const fechaFinVigenciaPut = fechaFinVigencia.format("YYYY-MM-DD");
    const [disbtn, setdisbtn] = useState(false);
    const [productos, setproductos] = useState([]);
    const [productoSelected, setproductoSelected] = useState('');
    const [cambieProd, setcambieProd] = useState(false);
    const [datosExisten, setdatosExisten] = useState();

    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    useEffect(() => {
        // Si cambio  el producto
        //seteo los valores en "" para qe no me queden los otros porque nada que ver
        //esos zapatitos nada que ver
        if (cambieProd) {
          // Resetear precios en `datoslista`
          setdatosLista((prevDatosLista) => ({
            ...prevDatosLista,  
            precio_iva: "",
            precio_sin_iva: "",           
          }));
        }
      }, [cambieProd]);


    useEffect(() => {
        getData('/productos/sector/250', setproductos)
    }, []);

    //useEffect para lista existente
    useEffect(() => {
        getData(`/lista_precios/existe/${productoSelected.idproducto}`, setdatosExisten)
    }, [productoSelected, setproductoSelected]);

    useEffect(() => {
        if (datoslista.precio_iva === "" || datoslista.precio_sin_iva === "" || datoslista.vigencia === "") {
            setdisbtn(true)
        }
        else {
            setdisbtn(false)
        }
    }, [datoslista])


    const almacenar = (event) => {
        const { name, value } = event.target;
        let newValue = { ...datoslista, [name]: value };

        //a medida que vamos llenando los inputs vammos haciendo el calculo del iva
        if (name === 'precio_sin_iva') {
            const precioIva = parseFloat(value) * productoSelected.valor;
            newValue.precio_iva = precioIva.toFixed(4);
        }

        if (name === 'precio_iva') {
            const precioIva = parseFloat(value) / productoSelected.valor;
            newValue.precio_sin_iva = precioIva.toFixed(4)
        }

        setdatosLista(newValue);
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
    };

    const size = "small";

    const handleClose = () => {
        props.alta(false);
        props.tabla(true);
    };

    async function updateVigencia(e) {
        putData(e,
            `/lista_precios/envasado/${datosExisten[0].id_lista}`,
            {
                fin_vigencia: fechaFinVigenciaPut,
                usuario: datoslista.usuario
            },
            setNotificacion
        )
    };

    async function guardarPrecio(e) {
        setdisbtn(true);
        postData(e,
            '/lista_precios/envasado',
            {
                id_producto: productoSelected.idproducto,
                precio_iva: datoslista.precio_iva,
                precio_sin_iva: datoslista.precio_sin_iva,
                usuario: datoslista.usuario,
                vigencia: datoslista.vigencia,
            },
            setNotificacion
        );
        if (fechaFinVigenciaPut) {
            
            updateVigencia(e)
        };

        logEventos("Guardar nueva lista de precios", "Lista de precios envasado", "Guardar y actualizar", localStorage.getItem('user'))
    };


    return (
        <div>
            <Container>
                <Title titulo={datosExisten && datosExisten.length === 0 ? "Nuevo Precio" : "Actualizar Precio"} handleClose={handleClose} />
                <Box
                    backgroundColor="#F4F6F6"
                    mt={2}
                    p={3}
                    mb={5}
                    border={0.5}
                    borderColor={"#ABB2B9"}
                    borderRadius={4}
                >
                    <Grid
                        container
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                    >
                        <Grid item xs={12}>
                            {productos && (
                                <Autocomplete
                                    disabled={!productos}
                                    size={size}
                                    disableClearable
                                    id="productos"
                                    noOptionsText={"Producto INEXISTENTE"}
                                    options={productos}
                                    autoHighlight
                                    getOptionLabel={(productos) =>
                                        productos.nombre
                                    }
                                    onChange={(event, value) => {
                                        setproductoSelected(value);
                                        setcambieProd(true)
                                    }}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            key={option.id}
                                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                            {...props}
                                        >
                                            {option.nombre}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            style={style}
                                            required
                                            focused
                                            size="small"
                                            placeholder="Tipee para buscar..."
                                            {...params}
                                            label="Producto"
                                            inputProps={{
                                                ...params.inputProps,
                                            }}
                                        />
                                    )}
                                />
                            )}
                        </Grid>
                        {
                            datosExisten && datosExisten.length === 0 ?
                                <FormPrecios
                                    size={size}
                                    style={style}
                                    almacenar={almacenar}
                                    datoslista={datoslista} />
                                :
                                <FormActualizar
                                    datosExisten={datosExisten}
                                    datoslista={datoslista}
                                    size={size}
                                    style={style}
                                    // fechaFinVigenciaFormat={fechaFinVigenciaFormat}
                                    setDatoslista={setdatosLista} />
                        }
                    </Grid>
                    <Grid
                        container
                        justifyContent="space-between"
                        alignItems="flex-end"
                        mt={2}
                    >
                        <Button variant="contained" onClick={handleClose} color="error">
                            Volver
                        </Button>

                        <Button
                            variant="contained"
                            type="submit"
                            color={"success"}
                            onClick={guardarPrecio}
                            disabled={disbtn}
                        >
                            {datosExisten && datosExisten.length > 0 ? "Actualizar" : "Guardar Precio"}
                        </Button>
                    </Grid>
                </Box>
                {notificacion && notificacion.open ? (
                    <Notify
                        mensaje={notificacion.mensaje}
                        open={notificacion.open}
                        color={notificacion.color}
                        handleClose={handleClose}
                        severity={notificacion.severity}
                    />
                ) : null}
            </Container>
        </div>
    )
}